/* eslint-disable global-require */
// eslint-disable-next-line import/no-unresolved
const processInclude = require('base/util');
const login = require('./components/login');
const oauth = require('./components/oauth');

let captcha;

if (window.grecaptcha) {
    captcha = require('./recaptcha/recaptcha');
}

$(document).ready(() => {
    processInclude(login);
    processInclude(oauth);

    if (window.grecaptcha) {
        processInclude(captcha);
    }
});
